import QuickActionDirection from 'components/common/QuickActionDirection';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { RowContainer, RowMeta } from '../styles';
import TicketRow from './TicketRow';

const LocationRow = ({
  uid,
  street,
  number,
  markerCoordinate,
}: {
  uid?: string;
  street: string;
  number: string;
  markerCoordinate: { latitude: number; longitude: number } | undefined;
}) => {
  const { t } = useTranslation();
  return (
    <TicketRow title={t('services.location')}>
      <RowContainer>
        <RowMeta testID={`permit-${uid}-location`}>
          {street}
          {!!street && ' ' + number}
        </RowMeta>
        <QuickActionDirection
          showIconLabel={false}
          markerCoordinate={markerCoordinate}
          alignEnd
        />
      </RowContainer>
    </TicketRow>
  );
};

export default LocationRow;
